import { callApi } from "@/api/api-core";

export const fetchInfo = function(ownerHandlesFailure) {
    return callApi(
        "POST",
        "v1/products/orangeticket/info",
        undefined,
        ownerHandlesFailure
    );
};

export const calculatePrice = function(
    tripId,
    passengers,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v1/products/orangeticket/price/calculate",
        {
            tripId,
            passengers
        },
        ownerHandlesFailure
    );
};

export const createOrder = function(
    tripId,
    productId,
    refundable,
    passengers,
    seating,
    ownerHandlesFailure
) {
    return callApi(
        "POST",
        "v4/products/orangeticket/order",
        {
            tripId,
            productId,
            refundable,
            passengers,
            seating,
            salesChannelIdentifier: "Webshop"
        },
        ownerHandlesFailure
    );
};
